import Swiper from 'swiper/bundle';

const sliderPhotoTypes = () => {
    const swiper = new Swiper(".js-photo-types", {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 40,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
        navigation: {
            nextEl: ".photo-types-next",
            prevEl: ".photo-types-prev",
        },
    });
}


export default sliderPhotoTypes